import _ from 'lodash'
import store from '@/stores/'
import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}

export default {
  id: 'text4',
  name: 'text4',
  type: 'standard',
  moduleName: 'editor_module_text4',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          color: _.cloneDeep(columnDetail.text),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          color: _.cloneDeep(columnDetail.text),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          color: _.cloneDeep(columnDetail.text),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          color: _.cloneDeep(columnDetail.text),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
